import { OBOL_CONTRACT_ADDRESS } from '../api/obolToken';
import { esc } from './components';

/**
 * Right-side header actions (X profile link + contract-address copy) shared
 * by the app topbar and the public homepage header. The copy button carries
 * the same public $OBOL mint the rest of the app uses (api/obolToken.ts —
 * mirrored from the backend token-gate/payment config; the real-token switch
 * updates that one constant). The click handling lives in main.ts
 * (`data-contract-copy-toast`).
 */

export const GRAVELIGHT_X_URL = 'https://x.com/PlayGravelight';

export function headerActionButtons(variant: 'topbar' | 'home'): string {
  const cls = variant === 'home' ? 'home-nav__link home-action' : 'navbtn topbar-action';
  const contractButton = OBOL_CONTRACT_ADDRESS
    ? `
    <button type="button" class="${cls}" data-contract-copy-toast data-copy-value="${esc(OBOL_CONTRACT_ADDRESS)}" aria-label="Copy the $OBOL contract address">Contract address</button>`
    : '';
  return `
    <a class="${cls}" href="${GRAVELIGHT_X_URL}" target="_blank" rel="noopener noreferrer" aria-label="Open Gravelight on Twitter">Twitter</a>${contractButton}`;
}
